<template>
  <div class="login-container">
    <div class="login-form-wrapper">
      <el-form :model="loginForm" :rules="loginRules" ref="loginForm" label-width="80px">
        <h2 class="login-title">管理系统登录</h2>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="loginForm.phone" placeholder="请输入手机号">
            <template #prepend>
              <i class="el-icon-mobile"></i>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="loginForm.password" type="password" placeholder="请输入密码" show-password>
            <template #prepend>
              <i class="el-icon-lock"></i>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleLogin" :loading="loading">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// 引入登录API
import { login } from '@/api/api'
// 引入认证工具函数
import { setToken, setUserInfo, removeToken } from '@/utils/auth'

export default {
  name: 'LoginPage',
  created() {
    // 页面加载时清空token，确保登录页面始终是未认证状态
    removeToken()
  },
  data() {
    return {
      loginForm: {
        phone: '',
        password: ''
      },
      loginRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号格式', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
//     {
//     "code": 200,
//     "status": "success",
//     "message": "操作成功",
//     "data": {
//         "token": "Wy4ftgRIbv8p7ZiKraidBciy0wwCV7rM",
//         "user": {
//             "id": 13,
//             "name": "白鑫鑫",
//             "phone": "18919966354",
//             "status": 1,
//             "created_at": "2026-02-09 14:30:13",
//             "updated_at": "2026-02-09 14:38:10",
//             "company_id": 950370,
//             "account": "18919966354",
//             "sex": 0,
//             "deleted_at": null,
//             "role": [
//                 {
//                     "id": 3,
//                     "title": "普通管理员",
//                     "slug": "plat-admin",
//                     "status": 1
//                 }
//             ],
//             "menu_list": [
//                 {
//                     "id": 5,
//                     "menu_name": "首页",
//                     "parent_id": 0,
//                     "sort": 0,
//                     "route_url": "/index",
//                     "component_path": null,
//                     "route_param": "",
//                     "route_name": "",
//                     "is_frame": 0,
//                     "type": 1,
//                     "is_show": 1,
//                     "perms": "/index",
//                     "icon": "s-home",
//                     "status": null,
//                     "created_at": "2026-02-05T01:18:54.000000Z",
//                     "updated_at": "2026-02-09T06:11:28.000000Z",
//                     "deleted_at": null,
//                     "children": []
//                 },
//                 {
//                     "id": 19,
//                     "menu_name": "公司",
//                     "parent_id": 0,
//                     "sort": 1,
//                     "route_url": "",
//                     "component_path": null,
//                     "route_param": "",
//                     "route_name": "",
//                     "is_frame": 0,
//                     "type": 0,
//                     "is_show": 1,
//                     "perms": "",
//                     "icon": "office-building",
//                     "status": null,
//                     "created_at": "2026-02-05T07:00:05.000000Z",
//                     "updated_at": "2026-02-09T06:11:37.000000Z",
//                     "deleted_at": null,
//                     "children": [
//                         {
//                             "id": 20,
//                             "menu_name": "公司管理",
//                             "parent_id": 19,
//                             "sort": 0,
//                             "route_url": "/company",
//                             "component_path": null,
//                             "route_param": "",
//                             "route_name": "",
//                             "is_frame": 0,
//                             "type": 1,
//                             "is_show": 1,
//                             "perms": "company",
//                             "icon": "",
//                             "status": null,
//                             "created_at": "2026-02-05T07:08:32.000000Z",
//                             "updated_at": "2026-02-05T07:08:32.000000Z",
//                             "deleted_at": null,
//                             "children": [
//                                 {
//                                     "id": 35,
//                                     "menu_name": "编辑",
//                                     "parent_id": 20,
//                                     "sort": 0,
//                                     "route_url": "",
//                                     "component_path": null,
//                                     "route_param": "",
//                                     "route_name": "",
//                                     "is_frame": 0,
//                                     "type": 2,
//                                     "is_show": 1,
//                                     "perms": "edit",
//                                     "icon": "",
//                                     "status": null,
//                                     "created_at": "2026-02-09T07:34:31.000000Z",
//                                     "updated_at": "2026-02-09T07:34:31.000000Z",
//                                     "deleted_at": null,
//                                     "children": []
//                                 }
//                             ]
//                         },
//                         {
//                             "id": 21,
//                             "menu_name": "账户管理",
//                             "parent_id": 19,
//                             "sort": 0,
//                             "route_url": "/account",
//                             "component_path": null,
//                             "route_param": "",
//                             "route_name": "",
//                             "is_frame": 0,
//                             "type": 1,
//                             "is_show": 1,
//                             "perms": "account",
//                             "icon": "",
//                             "status": null,
//                             "created_at": "2026-02-05T07:09:35.000000Z",
//                             "updated_at": "2026-02-05T07:09:35.000000Z",
//                             "deleted_at": null,
//                             "children": []
//                         },
//                         {
//                             "id": 22,
//                             "menu_name": "账户记录详情",
//                             "parent_id": 19,
//                             "sort": 0,
//                             "route_url": "/account/record",
//                             "component_path": null,
//                             "route_param": "",
//                             "route_name": "",
//                             "is_frame": 0,
//                             "type": 1,
//                             "is_show": 1,
//                             "perms": "record",
//                             "icon": "",
//                             "status": null,
//                             "created_at": "2026-02-05T07:11:12.000000Z",
//                             "updated_at": "2026-02-05T07:11:12.000000Z",
//                             "deleted_at": null,
//                             "children": []
//                         }
//                     ]
//                 }
//             ]
//         }
//     },
//     "request_id": "97395345-2032-4f18-a0cb-6f5f0eb832e7"
// }
    // 处理登录
    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            // 准备登录数据
            const loginData = {
              phone: this.loginForm.phone,
              password: this.loginForm.password
            }

            // 调用登录接口
            const response = await login(loginData)

            // 处理登录成功
            console.log('登录成功:', response)

            // 存储token
            if (response.data && response.data.token) {
              setToken(response.data.token)
              // 存储用户信息，包括menu_list
              if (response.data.user) {
                setUserInfo(response.data.user)
              }
            } else {
              // 如果后端返回格式不同，使用响应作为token
              setToken(response.token || JSON.stringify(response))
              // 尝试存储用户信息
              if (response.user) {
                setUserInfo(response.user)
              }
            }

            // 显示成功消息
            this.$message.success('登录成功')

            // 尝试跳转到首页
            try {
              if (this.$router) {
                this.$router.push('/index')
              } else {
                // 如果路由不存在，提示用户
                console.log('登录成功，准备跳转到首页')
                setTimeout(() => {
                  window.location.href = '/#/index' // 尝试使用hash模式跳转
                }, 1000)
              }
            } catch (routerError) {
              console.log('登录成功，但跳转失败:', routerError)
            }
          } catch (error) {
            // 处理登录失败
            console.error('登录失败:', error)
            this.$message.error(error.message || '登录失败，请重试')
          } finally {
            this.loading = false
          }
        } else {
          console.log('表单验证失败')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.page-content {
  padding: 0 !important;
}

.login-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  /* 渐变背景 */
  background: linear-gradient(135deg, #0F2027 0%, #203A43 50%, #2C5364 100%);
  /* 添加微妙的动画效果 */
  background-size: 400% 400%;
  animation: gradientBG 15s ease infinite;
  overflow: hidden;
  position: relative;
}

/* 背景动画 */
@keyframes gradientBG {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

/* 添加一些装饰性元素 */
.login-container::before,
.login-container::after {
  content: '';
  position: absolute;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  opacity: 0.1;
}

.login-container::before {
  background: rgba(255, 255, 255, 0.3);
  top: -50px;
  right: -50px;
  animation: float 15s ease-in-out infinite;
}

.login-container::after {
  background: rgba(255, 255, 255, 0.2);
  bottom: -50px;
  left: -50px;
  animation: float 18s ease-in-out infinite reverse;
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }

  50% {
    transform: translateY(-20px) rotate(5deg);
  }
}

.login-form-wrapper {
  width: 400px;
  padding: 40px;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(15, 32, 39, 0.37);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  z-index: 1;
  transition: all 0.3s ease-in-out;
}

.login-form-wrapper:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 40px rgba(15, 32, 39, 0.5);
}

.login-title {
  text-align: center;
  margin-bottom: 30px;
  color: #303133;
  font-weight: 600;
  letter-spacing: 1px;
}

.el-form-item {
  margin-bottom: 25px;
}

.el-button--primary {
  width: 100%;
  font-size: 16px;
  padding: 12px 0;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.el-button--primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(44, 83, 100, 0.4);
}

/* 输入框聚焦效果 */
.el-input__inner:focus {
  border-color: #2C5364;
  box-shadow: 0 0 0 2px rgba(44, 83, 100, 0.2);
}
</style>